import { DropdownField, NumberField, OutsideClick, Popup, PopupArrow, Tag } from '@cian/components';
import * as React from 'react';

import { Button } from '../../../../common/components/button';
import { TagNew } from '../TagNew';
import { EMetroTravelType } from '../../../../json_query';
import { getDefaultTravelTimeForType } from '../../../../utils/underground';

const style = require('./index.css');

export interface IStateProps {
  travelType: EMetroTravelType | undefined;
  travelTime: number | undefined;
  withNewTag: boolean;
}

export interface IDispatchProps {
  onUndergroundTravelChanged(travelType: EMetroTravelType, travelTime: number | undefined, withSearch?: boolean): void;
}

export interface IOwnProps {
  onDelete(): void;
}

export interface IUndergroundTravelState {
  isPopupVisible: boolean;
  travelType: EMetroTravelType;
  travelTime: number | undefined;
}

export type TUndergroundTravelProps = IStateProps & IDispatchProps & IOwnProps;

export class UndergroundTravel extends React.Component<TUndergroundTravelProps, IUndergroundTravelState> {
  private preventOutsideClick = false;

  public constructor(props: TUndergroundTravelProps) {
    super(props);

    const travelType = props.travelType || EMetroTravelType.Any;

    this.state = {
      isPopupVisible: false,
      travelType,
      travelTime: props.travelTime || getDefaultTravelTimeForType(travelType),
    };
  }

  public render() {
    const { isPopupVisible, travelType, travelTime } = this.state;

    if (this.props.withNewTag) {
      return (
        <div className={style['container-new']}>
          <TagNew onDeleteClick={this.handleDeleteClick}>
            {getButtonLabel(this.props.travelType, this.props.travelTime)}
          </TagNew>
        </div>
      );
    }

    return (
      <OutsideClick onOutsideClick={this.handleOutsideClick} rootElement={<div className={style['container']} />}>
        <Tag tagStyles={style['tag']} onClick={this.handleTagButtonClick} onDeleteClick={this.handleDeleteClick}>
          <span className={style['tag-text']}>{getButtonLabel(this.props.travelType, this.props.travelTime)}</span>
        </Tag>
        {isPopupVisible && (
          <Popup arrow={PopupArrow.LEFT} containerStyle={style['popup']}>
            <div className={style['inlineBlock']}>
              <span>До метро:</span>
              <DropdownField
                value={travelType}
                onValueChange={this.handleTravelTypeChange}
                values={[
                  { value: EMetroTravelType.Any, label: 'неважно' },
                  { value: EMetroTravelType.MapFoot, label: 'пешком' },
                  { value: EMetroTravelType.MapTransport, label: 'транспортом' },
                ]}
              />
            </div>
            {travelType !== EMetroTravelType.Any && (
              <div className={style['inlineBlock']}>
                <span>не более:</span>
                <NumberField
                  disableFractional
                  disableNegative
                  containerStyle={style['inlineBlock-input']}
                  value={travelTime}
                  onValueChange={this.handleTravelTimeChange}
                />
                <span>мин.</span>
              </div>
            )}
            <Button theme="primary" onClick={this.handleApplyButtonClick}>
              Применить
            </Button>
          </Popup>
        )}
      </OutsideClick>
    );
  }

  private open = () => {
    if (this.state.isPopupVisible) {
      return;
    }

    const travelType = this.props.travelType || EMetroTravelType.Any;

    this.setState({
      travelType,
      travelTime: this.props.travelTime || getDefaultTravelTimeForType(travelType),
      isPopupVisible: true,
    });
  };

  private close = () => {
    if (!this.state.isPopupVisible) {
      return;
    }

    this.setState({
      isPopupVisible: false,
    });
  };

  private handleOutsideClick = () => {
    if (this.preventOutsideClick) {
      this.preventOutsideClick = false;

      return;
    }

    this.close();
  };

  private handleTagButtonClick = () => {
    if (this.state.isPopupVisible) {
      this.close();
    } else {
      this.open();
    }
  };

  private handleTravelTypeChange = (value: EMetroTravelType) => {
    this.preventOutsideClick = true;

    this.setState({
      travelType: value,
    });
  };

  private handleTravelTimeChange = (value: number) => {
    this.setState({
      travelTime: value,
    });
  };

  private handleApplyButtonClick = () => {
    this.props.onUndergroundTravelChanged(
      this.state.travelType,
      this.state.travelTime || getDefaultTravelTimeForType(this.state.travelType),
      true,
    );

    this.close();
  };

  private handleDeleteClick = () => {
    if (this.props.travelType !== EMetroTravelType.Any || this.props.travelTime !== undefined) {
      this.props.onUndergroundTravelChanged(EMetroTravelType.Any, undefined, true);
    }
    this.close();

    this.props.onDelete();
  };
}

function getButtonLabel(travelType: EMetroTravelType | undefined, travelTime: number | undefined) {
  if (travelType === undefined && travelTime === undefined) {
    return 'Расстояние до метро';
  }

  return `До метро${travelTime !== undefined ? ` ${travelTime} мин.` : ''}${
    travelType !== undefined ? ` ${travelType === EMetroTravelType.MapFoot ? 'пешком' : 'транспортом'}` : ''
  }`;
}
